import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userDeviceList_loading: false,
    userDeviceList_data: null,
    userDeviceList_error: null,
    userDeviceList_success: false
  };
  

const UserEnrolledDevicesSlice = createSlice({
  name: 'UserEnrolledDevicesService',
  initialState,
  reducers: {
    UserEnrolledDevicesServiceInit(state) {
      state.userDeviceList_loading = true;
      state.userDeviceList_error = null;
    },
    UserEnrolledDevicesServiceSuccess(state, action) {
      state.userDeviceList_loading = false;
      state.userDeviceList_data = action.payload;
      state.userDeviceList_success = true
    },
    UserEnrolledDevicesServiceFailure(state, action) {
      state.userDeviceList_loading = false;
      state.userDeviceList_error = action.payload;
      state.userDeviceList_success = false
    },
    UserEnrolledDevicesServiceResetState: () => initialState
  },
});

export const { 
  UserEnrolledDevicesServiceInit, 
  UserEnrolledDevicesServiceSuccess, 
  UserEnrolledDevicesServiceFailure,
  UserEnrolledDevicesServiceResetState
} = UserEnrolledDevicesSlice.actions;

export default UserEnrolledDevicesSlice.reducer;
